import { Box, Grid, IconButton, Typography } from '@mui/material';
import type { Chat } from 'types/Chats/Chat';
import type { MemoryChat } from 'types/Memory/MemoryChats';
import React from 'react';

import DeleteMemoryQA from 'components/SVG/DeleteMemoryQA';
import { useUpdateMemoryChat } from 'hooks/memory/useUpdateMemoryChat';
import { formatDateAndTime } from 'utilities/time';
import { SparkEditableText } from 'sharedComponents/UI';
import { useUpdateChat } from 'hooks/chats/useUpdateChat';

type MemoryQACardProps = {
  memoryChat: MemoryChat;
  onMemoryChatClick: (memoryChat: MemoryChat) => void;
  chat: Chat | undefined;
  isSelected: boolean;
};

function MemoryChatListItem({
  memoryChat,
  onMemoryChatClick,
  chat,
  isSelected,
}: MemoryQACardProps) {
  const { mutate: updateMemoryChat } = useUpdateMemoryChat(memoryChat.id);
  const { mutate: updateChat } = useUpdateChat(chat?.id);
  const handleRenameChat = React.useCallback(
    (text: string) => {
      updateChat({ name: text });
    },
    [updateChat]
  );

  const handleDeleteChat = React.useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.stopPropagation();
      updateChat({ isDeleted: true });
    },
    [updateChat]
  );

  return (
    <Grid
      container
      paddingX={2}
      paddingY={1}
      justifyContent='space-between'
      alignItems='center'
      borderRadius='10px'
      border='1px solid'
      borderColor={(theme) =>
        isSelected ? theme.palette.primary.main : theme.palette.borderColor
      }
      onClick={() => onMemoryChatClick(memoryChat)}
      sx={{
        cursor: 'pointer',
        '&:hover': { borderColor: 'primary.main' },
      }}
    >
      <Box>
        <SparkEditableText
          initialText={chat?.attributes.name || ''}
          onTextChange={handleRenameChat}
          containerProps={{
            onClick: (e) => e.stopPropagation(),
          }}
          containerStyles={{ py: 0, my: 0.5 }}
        />
        <Typography variant='caption' color={'#BDBDBD'}>
          {formatDateAndTime(memoryChat.attributes.modifiedAt)}
        </Typography>
      </Box>
      <IconButton onClick={handleDeleteChat} sx={{ paddingRight: 0.8 }}>
        <DeleteMemoryQA color='var(--color-primary)' />
      </IconButton>
    </Grid>
  );
}

export default MemoryChatListItem;
